import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { OsService } from './os-service/os.service';
import { OsComponent } from './os/os.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  declarations: [
    OsComponent,
  ],
  exports: [
    OsComponent,
  ],
  providers : [
    OsService,
  ]
})
export class OsModule {
}
